import _ from 'lodash'

export function isNonNegativeNumber(value?: number): boolean {
  return _.isNumber(value) && _.toFinite(value) >= 0
}

export const calculatePercentage = (currentValue?: number, requiredValue?: number): number =>
  Math.max(0, Math.min(((currentValue || 0) / (requiredValue || 1)) * 100, 100))

export const clampPercent = (value: number): number => Math.max(0, Math.min(value, 100))
